import React, { useEffect, useState } from "react";
import { Badge, Breadcrumb, Select } from "antd";
import hideFilter from "../../assets/store/hideFilter.png";
import Product from "../Product";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesPro } from "../../redux/ecommerce/categoriesProductsSlice";
import { fetchProducts } from "../../redux/ecommerce/productsSlice";

const StoreProducts = ({
  categories,
  subcategories,
  selectedSubCategories,
  handleSubCategoryChange,
  handlePriceChange,
  collapsed,
  searchTerm
}) => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [hide, setHide] = useState(true);
  const [sortBy, setSortBy] = useState(null);

  const dispatch = useDispatch();

  const { categoriesProducts, status, error } = useSelector(
    (state) => state.categoriesProducts
  );

  const { products, statusPro, errorPro } = useSelector(
    (state) => state.products
  );

  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCategoriesPro());
    }
  }, [status, dispatch]);

  const allColors = [
    ...new Set(
      products
        .flatMap((product) =>
          product.colors?.map((color) => color.eco_color_id)
        )
        .filter(
          (color) =>
            typeof color === "string" &&
            /^#([0-9A-F]{3}){1,2}$/i.test(color)
        )
    ),
  ];

  const [selectedColors, setSelectedColors] = useState([]);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  useEffect(() => {

    if (selectedCategories === "" && !sortBy) return;

    const payload = {
      status: "recent",
    };

    if (selectedCategories.length > 0) {
      payload.category_id = selectedCategories;
    }

    if (sortBy) {
      payload.sort_by = sortBy;
    }

    dispatch(fetchProducts(payload));
  }, [selectedCategories, sortBy, dispatch]);

  useEffect(() => {
    if (statusPro === "succeeded") {
      dispatch(fetchProducts({ status: "recent", category_id: "" }));
    }
  }, [statusPro, dispatch]);

  const handleChange = (value) => {
    setSortBy(value);
  };

  const handleCategoryChange = (categoryId) => {
    setSelectedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleColorChange = (color) => {
    console.log("clicked color", color);
    setSelectedColors((prev) =>
      prev.includes(color)
        ? prev.filter((c) => c !== color)
        : [...prev, color]
    );
  };

  const handleHide = () => {
    if (hide === true) {
      setHide(false);
    } else {
      setHide(true);
    }
  };

  // const filteredProducts = products.filter((product) => {
  //   if (selectedCategories.length === 0) return true;

  //   return selectedCategories.includes(product.eco_category_id);
  // });

  const filteredProducts = products.filter((product) => {

    // Category
    const categoryMatch =
      selectedCategories.length === 0 ||
      selectedCategories.includes(product.eco_category_id);

    const colorMatch =
      selectedColors.length === 0 ||
      product.colors?.some((color) => {
        console.log("product color", color.eco_color_id);
        console.log("selected", selectedColors);

        return selectedColors.includes(
          color.eco_color_id?.trim().toLowerCase()
        );
      }

      );

    // Min Price
    const minPriceMatch =
      !minPrice || Number(product.price) >= Number(minPrice);

    // // Max Price
    const maxPriceMatch =
      !maxPrice || Number(product.price) <= Number(maxPrice);

    const searchMatch =
      !searchTerm ||
      (product.name_ar || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      (product.name_en || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

    return (
      categoryMatch &&
      colorMatch &&
      minPriceMatch &&
      maxPriceMatch &&
      searchMatch
    );
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case "price_low":
        return a.price - b.price;

      case "price_high":
        return b.price - a.price;

      case "highly_rated":
        return b.average_rating - a.average_rating;

      case "a_z":
        return (a.name_en || "").localeCompare(b.name_en || "");

      case "z_a":
        return (b.name_en || "").localeCompare(a.name_en || "");

      case "new":
        return new Date(b.created_at) - new Date(a.created_at);

      default:
        return 0;
    }
  });

  const filtersCount =
    selectedCategories.length +
    selectedColors.length +
    (minPrice ? 1 : 0) +
    (maxPrice ? 1 : 0);

  return (
    <>
      <div className={`px-20 max-lg:px-5 relative -top-28 StoreProducts ${language === "ar" && "StoreProductsAr"}`}>
        <div className="flex justify-between items-center">
          <Breadcrumb
            className="text-[#737E91] text-xl max-lg:text-lg"
            items={[
              {
                title: t("Products"),
              },
              {
                title: t("Store"),
              },
            ]}
          />
          <div className="flex gap-3 items-center ">
            <p className="text-[#283D63] font-semibold">{t("Sort")}:</p>
            <Select
              placeholder={language === "ar" ? "ترتيب حسب" : "Sort By"}
              style={{
                width: 150,
              }}
              className="border-2 border-[#4F71A8]"
              onChange={handleChange}
              options={[
                {
                  value: "relevance",
                  label: language === "ar" ? "الأكثر صلة" : "Relevance",
                },
                {
                  value: "a_z",
                  label: language === "ar" ? "الاسم (أ - ي)" : "Name (A-Z)",
                },
                {
                  value: "z_a",
                  label: language === "ar" ? "الاسم (ي - أ)" : "Name (Z-A)",
                },
                {
                  value: "price_low",
                  label:
                    language === "ar"
                      ? "السعر: من الأقل إلى الأعلى"
                      : "Price: Low to High",
                },
                {
                  value: "price_high",
                  label:
                    language === "ar"
                      ? "السعر: من الأعلى إلى الأقل"
                      : "Price: High to Low",
                },
                {
                  value: "new",
                  label: language === "ar" ? "الأحدث" : "Newest",
                },
                {
                  value: "highly_rated",
                  label:
                    language === "ar"
                      ? "الأعلى تقييماً"
                      : "Highest Rated",
                },
              ]}
            />
          </div>
        </div>
        <div
          className={`grid ${hide ? "" : "grid-cols-3"
            } max-lg:grid-cols-1 gap-10 mt-9`}
        >
          <div className="flex items-start">
            <div className={`bg-[#FCFBFA] rounded-3xl ${hide ? "" : "pt-5 w-full"}`}>
              <Badge count={filtersCount} className="mx-auto flex justify-center">
                <button
                  onClick={handleHide}
                  className="flex gap-3 items-center justify-center mx-auto rounded-full px-5 py-2 border-2 border-[#EAA182]"
                >
                  <img src={hideFilter} className="w-[25px]" />
                  <span className={`text-[#EAA182] text-xl`}>
                    {t("Hide filters")}
                  </span>
                </button>
              </Badge>

              <div className={`${hide ? "hidden" : ""} w-full p-4 px-7 bg-[#FCFBFA] rounded-b-3xl`}>
                {/* Product Category */}
                <div className="mb-4">
                  <h3 className="text-base font-semibold">{t("Product Category")}</h3>

                  {/* <div className="mb-2">
                    <label className="flex gap-2 items-center">
                      <input type="checkbox" />
                      <span>Accent chairs</span>
                    </label>
                  </div> */}
                  {categoriesProducts?.map((category) => (
                    <div key={category.id} className="mb-2">
                      <label className="flex gap-2 items-center cursor-pointer">
                        <input
                          type="checkbox"
                          value={category.id}
                          checked={selectedCategories.includes(category.id)}
                          onChange={() => handleCategoryChange(category.id)}
                        />

                        <span>
                          {language === "ar"
                            ? category.name
                            : category.name_en}
                        </span>
                      </label>
                    </div>
                  ))}
                </div>

                {/* <hr className="my-4" />

                <div className="mb-4">
                  <h3 className="text-lg font-semibold">Material</h3>

                  <div className="mb-2">
                    <label className="flex items-center">
                      <input type="checkbox" />
                      <span className="ml-2">Accent chairs</span>
                    </label>
                  </div>
                </div> */}

                <hr className="my-4" />

                <div className="mb-4">
                  <h3 className="text-base font-semibold">{t("Color")}</h3>

                  <div className="mt-4 flex items-center flex-wrap gap-2">
                    {allColors.length === 0 ? t("No colors") : allColors.map((color) => (
                      <button
                        key={color}
                        onClick={() => handleColorChange(color)}
                        style={{ backgroundColor: color }}
                        className={`w-[35px] h-[25px] rounded-lg border-2 ${selectedColors.includes(color)
                          ? "border-black"
                          : "border-gray-300"
                          }`}
                      />
                    ))}
                  </div>
                </div>

                <hr className="my-4" />

                {/* Price */}
                <div className="mb-4">
                  <h3 className="text-base font-semibold">{t("Price")}</h3>
                  <div className="flex gap-4 items-center mb-2">

                    <input
                      type="number"
                      placeholder={language === "en" ? "Min" : "الأقل"}
                      className="w-24 px-2 py-1 border rounded-lg"
                      value={minPrice}
                      onChange={(e) => setMinPrice(e.target.value)}
                    />

                    <input
                      type="number"
                      placeholder={language === "en" ? "Max" : "الأعلي"}
                      className="w-24 px-2 py-1 border rounded-lg"
                      value={maxPrice}
                      onChange={(e) => setMaxPrice(e.target.value)}
                    />
                  </div>
                </div>

                {/* <hr className="my-4" /> */}

                {/* Other */}
                {/* <div className="mb-4">
                  <h3 className="text-lg font-semibold">Other</h3>
                </div> */}
              </div>
            </div>

            {/* <div>2</div> */}
          </div>
          <div className="col-span-2">
            <div
              className={`grid ${hide ? "grid-cols-3" : "grid-cols-2"
                } max-lg:grid-cols-1 gap-10 max-lg:px-5`}
            >
              {/* {products.map((product, idx) => (
                <Product
                  key={idx}
                  id={product.id}
                  color_id={product.colors[0]?.id || null}
                  count={1}
                  image={`https://ecommerce.samoolah.com${product.image}`}
                  name={language === "en" ? product.name_en : product.name_ar}
                  price={product.price}
                  link={product.id}
                />
              ))} */}
              {(sortedProducts).map((product) => (
                <Product
                  key={product.id}
                  id={product.id}
                  color_id={product.colors?.[0]?.id || null}
                  count={1}
                  image={`https://ecommerce.samoolah.com${product.image}`}
                  name={language === "en" ? product.name_en : product.name_ar}
                  price={product.price}
                  link={product.id}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreProducts;
